import Plugin from 'src/plugin-system/plugin.class';

export default class EinzugsgebietGebietePlugin extends Plugin {

    init() {
        var self = this;
        var hash = window.location.hash;

        if (hash) {
            hash = hash.replace("#", "");
            var el = $('.is--' + hash + ' .collapse')
            el.collapse('show');

            $([document.documentElement, document.body]).animate({
                scrollTop: el.offset().top - 200
            }, 1000);
        }

        $(this.el).find('svg').mouseenter(function(){
            $(self.el).find('svg g').on('mouseover', function() {
                $(self.el).find('svg g').not(this).each(function(){
                    $(this).addClass('is--blurry');
                });
                $(this).removeClass('is--blurry');
            });
        }).mouseleave(function() {
            $(self.el).find('svg g').each(function(){
                $(this).removeClass('is--blurry');
            });
        });

        $(this.el).find('.einzugsgebiet-gebiete-widget__container').each(function() {
            //console.log( index + ": " + $( this ).text() );

            $(this).find('.collapse').first().on('shown.bs.collapse', function () {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(this).offset().top - 200
                }, 1000);
            });

        });
        
    }

}